<template>
  <div v-if="loading"  class="mt-220 d-flex justify-content-center align-items-center">
    <b-spinner label="Spinning" variant="primary"></b-spinner>
  </div>
  <div v-else class="mt-80">
    <div class="stories-page">
      <div
        class="stories-item"
        v-for="(item, id) in storieArray"
        :key="id">
        <b-row>
          <b-col cols="12">
            <div class="img-wrapper">
              <div class="link-mode">
                <button class="button" @click="$router.push(`story/${item.id}`)">Читать <under-arrow/></button>
              </div>
              <div class="img-holder image-block">
                <img :src="item.picture" class="img-fluid img-responsive contain image-content" alt="">
              </div>
            </div>
          </b-col>
        </b-row>
        <p class="stories-item-title">{{item.title}}</p>
        <pre><p class="stories-item-text">{{item.text | truncate(150)}} <span class="blue-link" @click="$router.push(`story/${item.id}`)">Подробнее</span></p></pre>
      </div>
    </div>
    <div class="mt-4 mb-5">
      <b-pagination-nav :link-gen="linkGen" :number-of-pages="pages" align="center" use-router></b-pagination-nav>
    </div>
    <Videos/>
    <Footer/>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex';
  import Footer from '@/views/Home/components/Footer';
  import Videos from '@/views/Home/components/Videos';
  import UnderArrow from '@/components/icons/UnderArrow';
  export default {
    name: "Stories",
    metaInfo: {
      title: 'Статьи'
    },
    components: {Footer, UnderArrow, Videos},
    data() {
      return {
        StoriesArr: [],
        storieArray: [],
        loading: true,
        pages: null
      }
    },
    beforeRouteEnter(to, from, next) {
      if (!to.query.page) next({ ...to, query: { page: 1, ...to.query } });
      else next();
    },
    computed: {
      ...mapGetters('stories', ['getStories'])
    },
    async mounted() {
      this.loading = true
      const response = await this.fetchStories()
      this.setStories(response.reverse())
      this.loading = false
      this.StoriesArr = this.getStories.reduce(function(result, value, index, array) {
        if (index % 4 === 0)
          result.push(array.slice(index, index + 4));
        return result;
      }, []);
      this.storieArray = this.StoriesArr[0]
      this.pages = this.StoriesArr.length
    },
    filters: {
      truncate: function (value, limit) {
        if (value.length > limit) {
          value = value.substring(0, (limit - 3)) + ' ...';
        }
        return value
      },
    },
    watch: {
      "$route.query.page": function (v) {
        if(v === undefined) {
          this.storieArray = this.StoriesArr[0]
        } else this.storieArray = this.StoriesArr[v-1]
        this.loading = true
        setTimeout(() => {
          this.loading = false
        }, 300)
      }
    },
    methods: {
      ...mapMutations('stories', ['setStories']),
      ...mapActions('stories', ['fetchStories']),
      linkGen(pageNum) {
        return pageNum === 1 ? '?page=1' : `?page=${pageNum}`
      }
    }
  }
</script>

<style lang="scss">
  .blue-link {
    cursor: pointer;
    color: #5ec8f5;
    transition: .5s;
  }
  .blue-link:hover {
    cursor: pointer;
    color: #0b97d3;
  }
  .stories-page {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    max-width: 1010px;
    padding: 110px 0 55px;
    margin-left: auto;
    margin-right: auto;
    .button {
      display: block;
      color: #fff;
      width: 181px;
      height: 48px;
      border-radius: 9px;
      background-color: #5ec8f5;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 17px;
      font-weight: 600;
      line-height: 1;
      color: #ffffff;
      border: none;
      svg {
        margin-left: 15px;
        transform: rotate(-90deg);
      }
    }
    .img-wrapper {
      position: relative;
      .link-mode {
        border-radius: 0 !important;
      }
    }
    .stories-item {
      display: block;
      max-width: 475px;
      width: 45%;
      margin-right: 0;
      border: none;
      font-family: 'Raleway', sans-serif;
      .img-block {
        width: 100%;
        height: 275px;
        background-size: cover;
        &:after {
          content: '';
          padding-top: 100px;
          display: block;
        }
      }
      .stories-item-title {
        font-size: 22px;
        margin-top: 16px;
        margin-bottom: 8px;
        font-weight: 600;
        color: #1f1f1f;
      }
      .stories-item-discription {

      }
      .stories-item-text {
        font-family: 'Raleway', sans-serif;
        font-size: 17px;
        line-height: 1.71;
        color: #1f1f1f;
        margin-bottom: 0;
      }
      img {
        max-width: 475px;
        width: 100%;
        display: block;
        margin-left: auto;
        margin-right: auto;
      }
    }
  }
  .img-loader {
    width: 100%;

    img {
      margin: auto;
      display: block;
      width: 166px;
      height: 166px;
    }
  }

  .img-holder {
    width: 100%;
    display: block;
    margin: auto;

    img {
      width: 100%;
      height: 196px;
      object-fit: cover;
    }
  }
  .image-block {
    position: relative;
    display: block;
    &:after{
      content: '';
      display: block;
      padding-top: 60%;
    }
    .loader-content{
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      width: 100%;
      height: 50%;
    }
    .image-content {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  @media screen and (max-width: 768px){
    .stories-page {
      flex-wrap: wrap;
      padding: 54px 24px 0;
      justify-content: center;
      .link-mode {
        display: flex !important;
        border-radius: 0 !important;
      }
      .stories-item {
        width: 90%;
      }
    }
  }
  @media screen and (max-width: 568px){
    .stories-page {
      .stories-item {
        width: 100%;
        .stories-item-title {
          font-size: 20px;
          margin-top: 16px;
          margin-bottom: 8px;
          font-weight: 600;
          color: #1f1f1f;
        }
        .stories-item-text {
          font-family: 'Raleway', sans-serif;
          font-size: 16px;
          line-height: 1.71;
          color: #1f1f1f;
        }
      }
    }
  }
</style>